import { useAuth } from '../hooks/AuthContext';

export const SecureComponent = ({ login, children }) => {
  const { session } = useAuth();

  if (!!session?.token) {
    return children;
  } else {
    localStorage.setItem('role', 'ADMIN');
    return login;
  }
};
